// Cross-feature helper (TS-2.5.04). Mirrors projects/lib/pageSizePreference.ts (D-259) for a
// second, simpler shape: a single on/off viewer preference with no vocabulary to validate. Unlike
// pageSizePreference.ts this uses localStorage, not sessionStorage - D-303's "hide live/completed"
// checkbox is a standing view preference the owner expects to persist across browser restarts, not
// just the current tab's session, so the two helpers intentionally use different Web Storage
// objects even though the try/catch shape is identical.
//
// Shared here rather than duplicated per feature (unlike admin/hooks/useOwnerSuggestions.ts, whose
// own header explains why ITS duplication is deliberate): that case diverges on business meaning
// per feature (free-text suggestion semantics), where this one does not - it is the same
// mechanical "remember one boolean, tolerate storage being unavailable" wrapper for both the
// Projects and Data quality pages, so one implementation serves both call sites.
export function readBooleanPreference(storageKey: string): boolean | null {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (raw === null) return null;
    return raw === "true";
  } catch {
    return null;
  }
}

/** Best-effort only: a failure to persist leaves the page working with its in-memory choice. */
export function writeBooleanPreference(storageKey: string, value: boolean): void {
  try {
    window.localStorage.setItem(storageKey, String(value));
  } catch {
    // Ignored: see file header.
  }
}
